import { emailTemplateSchema } from "@redotech/redo-marketing-templates-common/email-template";
import * as z from "zod";

export const getOriginEmailTemplates = {
  name: "getOriginEmailTemplates" as const,
  input: z.object({}),
  output: z.array(
    emailTemplateSchema.extend({ isOrigin: z.boolean().optional() }),
  ),
};
